import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40f2c6b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"24px","margin-bottom":"24px","margin-left":"10px"} }, " 房屋租赁等合同审核 ", -1))
const _hoisted_2 = { class: "infomation-seal-content" }
const _hoisted_3 = {
  class: "item text-overflow",
  style: {"display":"inline-block","margin-right":"257px","margin-bottom":"0px","margin-left":"10px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "房东联系方式：", -1))
const _hoisted_5 = {
  class: "item text-overflow",
  style: {"display":"inline-block","margin-bottom":"0px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "打款账号：", -1))
const _hoisted_7 = { class: "rent-contract-applyDetail" }
const _hoisted_8 = { class: "sign-table-wrapper" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { houseRentChangeDetail } from "@/api/change_process";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false },
    traceId: { default: "" }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean, traceId: string }





watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const RentContactMobile = ref<string>("");
const RentBankAccount = ref<string>("");
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);

onMounted(async () => {
  getdata();
});

const getdata = async () => {
  const { Data } = await houseRentChangeDetail({
    Id: props.folwId,
    TraceId: props.traceId,
  });
  RentContactMobile.value = Data.RentContactMobile || "";
  RentBankAccount.value = Data.RentBankAccount || "";
  tableData.value = [
    ...((Data?.PageFiles.length > 0 && Data?.PageFiles) || []),
    ...((Data?.BackPageFiles.length > 0 && Data?.BackPageFiles) || []),
  ];
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo:Data?.ApplicationInfo,
    ApplicationTime:Data?.ApplicationTime,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "租赁合同审核",
      style: {"margin-top":"24px"}
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(RentContactMobile.value), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(RentBankAccount.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})